import { dataAudio } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAudio = /*#__PURE__*/createIcon(dataAudio)
export default IconAudio
